import React, { useEffect, useState } from 'react';
import AboutUs from './AboutUs';
import FeatureCard from './FeatureCard';
import About2 from './About2';
import OnlyForm from './OnlyForm';
import { useLocation } from 'react-router-dom';



import Footer from './Footer';


const Home = () => {
    return (
        <div>
            <AboutUs />
            <About2 />
            <OnlyForm />

            <Footer />


        </div>
    );
};

export default Home;